import {
  getDownloadURL,
  listAll,
  ref,
  Storage,
  StorageReference
} from '@angular/fire/storage';

export abstract class CloudStorageService {
  abstract storage: Storage;

  async listFilesAndGetPublicLinks(folderPath = '/'): Promise<string[]> {
    const listRef = ref(this.storage, folderPath);

    // listAll fetches all items and prefixes (up to a certain limit for listAll())
    const listAllTask = await listAll(listRef);
    return Promise.all(
      listAllTask.items.map((itemRef: StorageReference) =>
        getDownloadURL(itemRef)
      )
    );
  }
}
